import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/PageHeader';
import { useAuth } from '@/lib/auth/useAuth';
import { IssueListTable } from '@/features/issues/components/IssueListTable';

export function IssuesListPage() {
  const { hasRole } = useAuth();
  const isAdmin = hasRole('admin');

  return (
    <div className="space-y-6">
      <PageHeader
        title="Issues"
        actions={
          <Button asChild>
            <Link to="/issues/new">
              <Plus className="size-4" />
              New
            </Link>
          </Button>
        }
      />
      <IssueListTable isAdmin={isAdmin} />
    </div>
  );
}
